import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

function CancellationAndRefund() {
  return (
    <div className="privacy-page">
      {/* Header */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/#about">About</Link>
          <Link to="/#branches">Branches</Link>
          <Link to="/#services">Services</Link>
          <Link to="/#gallery">Gallery</Link>
        </nav>
      </header>

      {/* Cancellation and Refund Content */}
      <div className="privacy-content-page">
        <div className="container">
          <button className="close-btn" onClick={() => window.history.back()}>
            ✖
          </button>
          <h1>Cancellation and Refund</h1>
          <p><strong>Last Updated: November 26, 2025</strong></p>
          <p>ALIVE HOSPITALITY believes in helping its customers as far as possible, and has therefore a liberal cancellation policy.</p>
          <p>Under this policy: Cancellations will be considered only if the request is made within 1-2 days of placing the order.</p>
          <p>However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.</p>
          <p>ALIVE HOSPITALITY does not accept cancellation requests for perishable items like flowers, eatables etc.</p>
          <p>However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.</p>
          <p>In case of receipt of damaged or defective items please report the same to our Customer Service team.</p>
          <p>The request will, however, be entertained once the merchant has checked and determined the same at his own end.</p>
          <p>This should be reported within 1-2 days of receipt of the products.</p>
          <p>In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 1-2 days of receiving the product.</p>
          <p>The Customer Service Team after looking into your complaint will take an appropriate decision.</p>
          <p>In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.</p>
          <p>In case of any Refunds approved by the ALIVE HOSPITALITY, it'll take 3-5 days for the refund to be processed to the end customer.</p>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive Hospitality. All Rights Reserved to alive hospitality.</p>
      </footer>
    </div>
  );
}

export default CancellationAndRefund;
